import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent {
  @Input() currentStep: number = 0;
  @Input() steps: { title: string }[] = [];
  @Input() withMargin : boolean = true;
}
